import React, { useState, useEffect, useRef } from 'react';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import { Link } from "react-router-dom";
import logo from "../assets/images/logo.png";
import bell from "../assets/images/bell.png";
import cart from "../assets/images/cart.png";
import { useCart } from "../context/CartContext";
import Notification from '../pages/Notification';
import { getUnreadNotifications } from '../services/notificationApi';

function Header() {
  const { cartItems } = useCart();
  const user = JSON.parse(localStorage.getItem("user"));
  const [showNotifications, setShowNotifications] = useState(false);
  const notificationRef = useRef(null);
  const [unreadCount, setUnreadCount] = useState(0);

  // Toggle notification dropdown
  const toggleNotifications = () => {
    setShowNotifications((prev) => !prev);
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (notificationRef.current && !notificationRef.current.contains(event.target)) {
        setShowNotifications(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    const fetchUnreadCount = async () => {
      const response = await getUnreadNotifications();
      if (response?.data) {
        setUnreadCount(response.data.length);
      }
    };
    fetchUnreadCount();
  }, []);

  return (
    <div className='app-container'>
      {user.role === "Parent" ?
        <Navbar expand="lg" className='custom-nav'>
          <Container>
            <Navbar.Brand as={Link} to="/dashboard"><img
              src={logo}
              alt="Logo"
              height="60"
              className="d-inline-block align-top"
            /></Navbar.Brand>
            <div className='mobileHeader d-block d-lg-none'>
              <ul className=' d-flex gap-2'>
                <li ref={notificationRef} className="position-relative">
                  <Link onClick={toggleNotifications} className="cursor-pointer">
                    <img src={bell} alt="bell" />
                    <span className='bg-danger fw-6'>{unreadCount || 0}</span>
                  </Link>
                  {showNotifications && (
                    <Notification />
                  )}
                </li>
                <li>
                  <Link to='/cart'>
                    <img src={cart} alt="cart" />
                    <span className='bg-danger fw-6'>{cartItems.length || 0}</span>
                  </Link>
                </li>
              </ul>
            </div>
            <Navbar.Toggle aria-controls="basic-navbar-nav" className='d-none' />
            <Navbar.Collapse id="basic-navbar-nav">
              <Nav className="ms-auto">
                <Nav.Link as={Link} to="/dashboard">Home</Nav.Link>
                <Nav.Link as={Link} to="/programs">Programs</Nav.Link>
                <Nav.Link as={Link} to="/schedule">Schedule</Nav.Link>
                <Nav.Link as={Link} to="/wallet">Wallet</Nav.Link>
                <Nav.Link as={Link} to="/account">Account</Nav.Link>
                <Nav.Link ref={notificationRef} className="position-relative" >
                  <span onClick={toggleNotifications} className="cursor-pointer">
                    Alerts
                    <span className='text-white px-2 rounded-4 bg-danger ms-1'>{unreadCount || 0}</span>
                  </span>
                  {showNotifications && (
                    <Notification />
                  )}
                </Nav.Link>
                <Nav.Link as={Link} to="/cart">Cart <span className="text-white px-2 rounded-4 bg-danger">{cartItems.length || 0}</span></Nav.Link>
              </Nav>
            </Navbar.Collapse>
          </Container>
        </Navbar>
        :
        <Navbar expand="lg" className='custom-nav'>
          <Container>
            <Navbar.Brand as={Link} to="/teacherDashboard"><img
              src={logo}
              alt="Logo"
              height="60"
              className="d-inline-block align-top"
            /></Navbar.Brand>
            <div className='mobileHeader d-block d-lg-none'>
              <ul className=' d-flex gap-2'>
                {/* <li>
                <Link to='/dashboard'>
                  <img src={bell} alt="bell" />
                  <span className='bg-danger fw-6'>0</span>
                </Link>
              </li> */}
              </ul>
            </div>
            <Navbar.Toggle aria-controls="basic-navbar-nav" className='d-none' />
            <Navbar.Collapse id="basic-navbar-nav">
              <Nav className="ms-auto">
                <Nav.Link as={Link} to="/teacherDashboard">Home</Nav.Link>
                <Nav.Link as={Link} to="/allocatedClasses">Schedule</Nav.Link>
                <Nav.Link as={Link} to="/account">Account</Nav.Link>
              </Nav>
            </Navbar.Collapse>
          </Container>
        </Navbar>
      }

    </div>
  );
}

export default Header;
